import { Route, Routes } from "react-router-dom";
import { NotFoundPage } from "../pages/pageNotFound";
import { HomePage } from "../pages/home/index";
import { LeandsPage } from "@/pages/leads/index";
import { Login, AuthenticateJWT } from "../pages/Login/index";
import { WhatsappForm } from "../pages/whatsappForm/whatsappForm";
import { ClientPage } from "@/pages/clientes/index.tsx";
import { ClientContextProvider } from "../contexts/ClientContext";
import { KanbanPage } from "@/pages/kanban";
import { LeadProvider } from "@/pages/leads/context/leadContext";
import { Configuracoes } from "@/pages/Configuracao";
import { NetPromoterScore } from "@/pages/NetPromoterScore";
import { NpsProvider } from "@/contexts/Nps";

export function Router() {
  return (
    <Routes>
      <Route
        path="/homePage"
        element={
          <ClientContextProvider>
            <HomePage />
          </ClientContextProvider>
        }
      />
      <Route
        path="/leadsPage"
        element={
          <ClientContextProvider>
            <LeandsPage />
          </ClientContextProvider>
        }
      />
      <Route path="/kanbanPage" element={
        <LeadProvider>
          <ClientContextProvider>
            <KanbanPage />
          </ClientContextProvider>
        </LeadProvider>
      } />
      <Route path="/" element={<Login />} />
      <Route path="/auth" element={<AuthenticateJWT />} />
      <Route path="/configuracoes" element={<Configuracoes />} />
      <Route path="*" element={<NotFoundPage />} />
      <Route path="/ads" element={<WhatsappForm />} />
      <Route path="/atendimento" element={<WhatsappForm />} />
      <Route path="/clientes" element={
        <ClientContextProvider>
          <ClientPage />
        </ClientContextProvider>
      } />
      <Route path="netPromoterScore" 
        element={
          <NpsProvider>
            <NetPromoterScore />
          </NpsProvider>
        } 
      />


    </Routes>
  );
}
